export default defineAppConfig({
    ui: {
        colors: {
            primary: 'amber',
            neutral: 'stone',
            // Pass-through Tailwind palettes for badges that used these in Nuxt UI v2
            purple: 'purple',
            violet: 'violet',
        },
        // v2 inputs/selects/textareas were full-width by default; v4 is inline-flex
        input: {
            slots: {
                root: 'w-full'
            }
        },
        select: {
            slots: {
                base: 'w-full'
            }
        },
        selectMenu: {
            slots: {
                base: 'w-full'
            }
        },
        textarea: {
            slots: {
                root: 'w-full'
            }
        },
        // v2 override kept dropdowns above sticky headers
        dropdownMenu: {
            slots: {
                content: 'z-50'
            }
        },
        // Restore Nuxt UI v2's size scale: v4 renamed every size one notch
        // down (v4 md == v2 sm), so both defaults and explicit size props in
        // templates would otherwise render smaller than before the upgrade.
        button: {
            variants: {
                size: {
                    xs: { base: 'text-xs px-2.5 py-1.5 gap-x-1.5' },
                    sm: { base: 'text-sm px-2.5 py-1.5 gap-x-1.5' },
                    md: { base: 'text-sm px-3 py-2 gap-x-2' },
                    lg: { base: 'text-sm px-3.5 py-2.5 gap-x-2.5' },
                    xl: { base: 'text-base px-3.5 py-2.5 gap-x-2.5' }
                }
            }
        },
        badge: {
            variants: {
                size: {
                    xs: { base: 'text-xs px-1.5 py-0.5 rounded-md' },
                    sm: { base: 'text-xs px-2 py-1 rounded-md' },
                    md: { base: 'text-sm px-2 py-1 rounded-md' },
                    lg: { base: 'text-sm px-2.5 py-1.5 rounded-md' },
                    xl: { base: 'text-sm px-2.5 py-1.5 rounded-md' }
                }
            }
        }
    }
})
